import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { TransfersOtherBanksComponent } from './transfers-other-banks.component';
import { SharedModule } from './../../shared/shared.module';
import { FavoredDataComponent } from './favored-data/favored-data.component';
import { NgxMaskModule } from 'ngx-mask';
import { MatButtonModule, MatCheckboxModule, MatIconModule, MatListModule, MatRadioModule, MatSelectModule, MatTabsModule } from '@angular/material';
import { TransferDataComponent } from './transfer-data/transfer-data.component';
import { TransferTypeComponent } from './transfer-type/transfer-type.component';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TransferConfirmationComponent } from './transfer-confirmation/transfer-confirmation.component';
import { SecurityCheckComponent } from './security-check/security-check.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TransfersOtherBanksService } from './transfers-other-banks.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TransferResultComponent } from './transfer-result/transfer-result.component';
import { TextMaskModule } from 'angular2-text-mask';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { TransactionHandlerService } from './transfer-response/services/transaction-handler.service';
import { ReceiptsModule } from '../receipts/receipts.module';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		CurrencyMaskModule,
		NgxMaskModule.forRoot(),
		MatCheckboxModule,
		MatButtonModule,
		MatListModule,
		MatRadioModule,
		MatDatepickerModule,
		FormsModule,
		ReactiveFormsModule,
		ReceiptsModule,
		RouterModule,
		MatSelectModule,
		MatAutocompleteModule,
		TextMaskModule,
		MatTabsModule,
		MatTableModule,
		MatInputModule,
		MatIconModule,

	],
	declarations: [
		TransfersOtherBanksComponent,
		TransferTypeComponent,
		FavoredDataComponent,
		TransferDataComponent,
		TransferConfirmationComponent,
		SecurityCheckComponent,
		TransferResultComponent
	],
	exports: [
		TransferTypeComponent,
		TransferConfirmationComponent,
		TransfersOtherBanksComponent,
		SecurityCheckComponent,
		TransferResultComponent,
		MatTableModule,
		FavoredDataComponent,
		MatInputModule
	],
	providers: [TransfersOtherBanksService, TransactionHandlerService]

})
export class TransfersOtherBanksModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfers-other-banks.module.ts